import { render, staticRenderFns } from "./mechant-documents.vue?vue&type=template&id=ca1ce956"
import script from "./mechant-documents.vue?vue&type=script&lang=js"
export * from "./mechant-documents.vue?vue&type=script&lang=js"
import style0 from "./mechant-documents.vue?vue&type=style&index=0&id=ca1ce956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports